import { useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import UserInformation from "./UserInformation";
import clsx from "clsx";
import CellMenu from "../../../components/CellMenu";

const ResponsiblePersonLabel = ({ person, label, request, cellSubMenuOptions, }) => {

  const classes = useStyles();
  const [popover, setPopover] = useState({ element: null, data: {} });
  const [timeOutId, setTimeOutId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [position, setPosition] = useState({ x: 0, y: 0 })

  const handleMenuClose = (event) => {
    event?.stopPropagation?.();
    setAnchorEl(null);
  };

  const handlePopoverClose = (e) => {
    e && e.stopPropagation && e.stopPropagation();
    clearTimeout(timeOutId);
    setPopover((p) => ({ element: null, data: {} }));
  };
  const handlePopoverOpen = ({ currentTarget }, data) => {
    clearTimeout(timeOutId);
    const id = setTimeout(() => {
      setPopover({ element: currentTarget, data });
    }, [1500]);
    setTimeOutId(id);
  };
  const open = Boolean(popover.element);

  const contextProps = useMemo(() => {
    const handleContextMenu = (event) => {
      event.preventDefault();
      setPosition({
        x: event.clientX,
        y: event.clientY
      })
      setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    if (cellSubMenuOptions?.options?.length > 0) {
      return {
        onContextMenu: handleContextMenu
      }
    }
    return {}
  }, [cellSubMenuOptions?.options?.length, anchorEl])
  return (
    <>
      <Box className={classes.cellContainer} {...contextProps} >
        <Typography
          variant="caption"
          className={clsx(classes.customTableCell, classes.content)}
          aria-owns={open ? "user-info" : undefined}
          aria-haspopup="true"
          onMouseOver={(e) =>
            handlePopoverOpen(e, {
              userInformation: person,
              surveyingMomentId: request.surveyingMomentId,
            })
          }
          onMouseLeave={() => {
            clearTimeout(timeOutId);
          }}
        >
          {label ? label : ""}
        </Typography>
        {cellSubMenuOptions?.options?.length > 0 && <CellMenu cellData={label} cellSubMenuOptions={cellSubMenuOptions} row={request} anchorEl={anchorEl} handleMenuClose={handleMenuClose} position={position} />}
      </Box>

      <UserInformation
        requestKey={"updateResponsiblePersonMoments"}
        open={open}
        projectId={request && request.projectId}
        repairRequestRight={false}
        hideExtraInfo
        data={popover.data}
        anchorEl={popover.element}
        disableRestoreFocus
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onMouseLeave={handlePopoverClose}
        onClose={handlePopoverClose}
      />
      <div className={classes.spacer}> {person ? person.relationName : ""}</div>
      <span>&nbsp;</span>
    </>
  );
};
const useStyles = makeStyles((theme) => ({

  customTableCell: {
    [theme.breakpoints.only("xs")]: {
      fontSize: 14,
    },
    [theme.breakpoints.only("sm")]: {
      fontSize: 16,
    },
    [theme.breakpoints.up("sm")]: {
      whiteSpace: "nowrap",
    },
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },

  content: {
    position: "absolute",
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  cellContainer: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
    width: "100%",
    height: "100%"
  },
  spacer: {
    height: 0,
    overflow: "hidden",
  },
}));
export default ResponsiblePersonLabel;
